import React, { useState } from 'react';
import { HelpCircle, ChevronDown, ChevronUp } from 'lucide-react';

// Shared FAQ accordion — previously duplicated near-verbatim across
// PrimaryEducationHub, SecondaryEducationHub and SecondChanceEducationHub.
export const FAQAccordion = ({ title = 'Frequently Asked Questions', faqs }) => {
  const [openIndex, setOpenIndex] = useState(null);

  return (
    <div className="bg-white rounded-2xl border border-gray-200 p-6 mb-8">
      <div className="flex items-center gap-3 mb-6">
        <div className="w-12 h-12 bg-brand-100 rounded-xl flex items-center justify-center">
          <HelpCircle className="w-6 h-6 text-brand-600" />
        </div>
        <h2 className="text-xl font-bold text-gray-800">{title}</h2>
      </div>

      <div className="space-y-3">
        {faqs.map((faq, idx) => (
          <div key={idx} className="border border-gray-100 rounded-xl overflow-hidden">
            <button
              onClick={() => setOpenIndex(openIndex === idx ? null : idx)}
              className="w-full p-4 text-left flex items-center justify-between hover:bg-gray-50"
            >
              <span className="font-medium text-gray-800 pr-4">{faq.q}</span>
              {openIndex === idx ? (
                <ChevronUp className="w-5 h-5 text-gray-400 flex-shrink-0" />
              ) : (
                <ChevronDown className="w-5 h-5 text-gray-400 flex-shrink-0" />
              )}
            </button>
            {openIndex === idx && (
              <div className="px-4 pb-4 text-gray-600 text-sm border-t border-gray-100 pt-3 bg-gray-50">
                {faq.a}
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default FAQAccordion;
